import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Box, Table, TableBody, TableCell, TableHead, TableRow, IconButton, Typography } from '@mui/material';
import { Delete, Edit, Settings } from '@mui/icons-material';
import { toast } from 'react-toastify';
import MainCard from 'components/Cards/MainCard';
import { API_URL, gridSpacing } from 'utils/constants';
import ApiHelper from 'utils/apiHelper';
import EditOrganizationDialog from './EditOrganizationDialog';
import ManageOrganizationDialog from './ManageOrganizationDialog';
import DeleteConfirmationDialog from 'components/Management/DeleteConfirmationDialog';
import { getOrganizationData, selectManagingOrg } from 'components/../redux/actions/management';
import { useNavigate } from 'react-router-dom';
import ACTION_TYPE from 'components/../redux/actions/actionTypes';

const ManagementOrganizations = () => {
    const { userInfo } = useSelector((state) => state.auth);
    const manageOrganizationData = useSelector((state) => state.management.organization?.selected);
    const { isLoading, data } = useSelector((state) => state.management.organization);
    const [manageOrganizationDialog, setManageOrganizationDialog] = useState(false);
    const [showEditOrganizationDialog, setShowEditOrganizationDialog] = useState(false);
    const [selectedOrganizationData, setSelectedOrganizationData] = useState();
    const [deleteOrganizationId, setDeleteOrganizationId] = useState();
    const [showDeleteConfirmationDialog, setShowDeleteConfirmationDialog] = useState(false);
    const [newlyManaged, setNewlyManaged] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(getOrganizationData());
        setNewlyManaged(false);
    }, [dispatch]);

    const handleEditOrganization = (data) => {
        setShowEditOrganizationDialog(true);
        setSelectedOrganizationData(data);
    };

    const handleManageOrganization = async (data) => {
        setSelectedOrganizationData(data);
        setManageOrganizationDialog(true);
    };

    const handleCloseEditOrganization = () => {
        setShowEditOrganizationDialog(false);
        dispatch(getOrganizationData());
    };

    const handleDeleteConfirmation = (id) => {
        setShowDeleteConfirmationDialog(true);
        setDeleteOrganizationId(id);
    };

    const handleClose = () => {
        setShowDeleteConfirmationDialog(false);
    };

    const handleDeleteOrganization = () => {
        ApiHelper.delete(`${API_URL.MANAGEMENT_ORGANIZATION_DATA}${deleteOrganizationId}/`)
            .then(() => {
                toast.success('Organization was deleted successfully.');
                dispatch(getOrganizationData());
                handleClose();
            })
            .catch(() => {
                toast.error('Failed to delete a organization.');
                handleClose();
            });
    };
    const handleManageOrganizationData = () => {
        // dispatch(selectManagingOrg(selectedOrganizationData))
        //     .then(() => {
        //         // This will run after the dispatch is complete
        //         setManageOrganizationDialog(false);
        //         console.log('here2');
        //         navigate('/home');
        //     })
        //     .catch((error) => {
        //         // Handle any errors that occur during the dispatch
        //         console.error('Error managing organization:', error);
        //     });
        dispatch({
            type: ACTION_TYPE.LOADING_MANAGEMENT_DTL,
            fieldName: 'organization',
            data: true
        });

        ApiHelper.post(API_URL.MANAGING_ORGANIZATION, {
            manage_organization_id: selectedOrganizationData.orgid
        })
            .then(() => {
                dispatch({
                    type: ACTION_TYPE.UPDATE_MANAGEMENT_DTL,
                    fieldName: 'organization',
                    data: {
                        selected: selectedOrganizationData
                    }
                });
                setManageOrganizationDialog(false);
                navigate('/home');
                return Promise.resolve();
            })
            .catch((err) => {
                if (err.response.data.message !== '') {
                    toast.error(`Failed! ${err.response.data.message}`);
                } else {
                    toast.error('Failed to manage the organization');
                }
                dispatch({
                    type: ACTION_TYPE.LOADING_MANAGEMENT_DTL,
                    fieldName: 'organization',
                    data: false
                });
            });
    };

    if (!data) {
        return null;
    } else {
        return (
            <MainCard
                title="Organization Management"
                cardHeaderShow={true}
                cardHeaderTitle={manageOrganizationData?.orgid ? manageOrganizationData?.name : userInfo.user.orgid.name}
            >
                <Grid container spacing={gridSpacing}>
                    <Grid item xs={12}>
                        {/*<Grid*/}
                        {/*    container*/}
                        {/*    item*/}
                        {/*    sx={{*/}
                        {/*        background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.primary[200]})`,*/}
                        {/*        padding: 1*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    <Grid item xs={12}>*/}
                        {/*        <Button*/}
                        {/*            sx={{ float: 'right', backgroundColor: '#FFFFFF', borderRadius: '6px' }}*/}
                        {/*            onClick={() => setRegisterOrganizationDialog(true)}*/}
                        {/*            startIcon={<Add />}*/}
                        {/*        >*/}
                        {/*            Register Organization*/}
                        {/*        </Button>*/}
                        {/*        {registerOrganizationDialog && (*/}
                        {/*            <RegisterOrganizationDialog onClose={() => setRegisterOrganizationDialog(false)} />*/}
                        {/*        )}*/}
                        {/*    </Grid>*/}
                        {/*</Grid>*/}
                        <Grid container spacing={gridSpacing}>
                            <Grid item lg={12} xs={12}>
                                {isLoading === true ? (
                                    <Typography sx={{ mt: 3, textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}>
                                        Please wait...
                                    </Typography>
                                ) : data?.length === 0 ? (
                                    <Typography sx={{ mt: 3, textAlign: 'center' }}>No Organizations Data</Typography>
                                ) : (
                                    <Table sx={{ minWidth: 700 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Organization Name</TableCell>
                                                <TableCell>Organization Description</TableCell>
                                                <TableCell>Organization Address</TableCell>
                                                <TableCell>Account Locked</TableCell>
                                                <TableCell>Auto Upgrade</TableCell>
                                                <TableCell>Baseline Set</TableCell>
                                                <TableCell>Options</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.map((data, key) => (
                                                <TableRow key={key}>
                                                    <TableCell>
                                                        {manageOrganizationData?.orgid === data.orgid
                                                            ? `${data.name} - managing`
                                                            : data.name}
                                                    </TableCell>
                                                    <TableCell>{data.description}</TableCell>
                                                    <TableCell>{data.address}</TableCell>
                                                    <TableCell>{data.locked === true ? 'Yes' : 'No'}</TableCell>
                                                    <TableCell>{data.autoupgrade === true ? 'Yes' : 'No'}</TableCell>
                                                    <TableCell>{data.baseline_set === true ? 'Yes' : 'No'}</TableCell>
                                                    <TableCell>
                                                        <Box>
                                                            {userInfo.admin_permissions.root_admin && (
                                                                <IconButton size="small" onClick={() => handleManageOrganization(data)}>
                                                                    <Settings fontSize="small" />
                                                                </IconButton>
                                                            )}
                                                            <IconButton size="small" onClick={() => handleEditOrganization(data)}>
                                                                <Edit fontSize="small" />
                                                            </IconButton>
                                                            <IconButton size="small" onClick={() => handleDeleteConfirmation(data.orgid)}>
                                                                <Delete fontSize="small" />
                                                            </IconButton>
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            {manageOrganizationDialog && (
                                                <ManageOrganizationDialog
                                                    onSubmit={handleManageOrganizationData}
                                                    onClose={() => setManageOrganizationDialog(false)}
                                                />
                                            )}
                                            {showEditOrganizationDialog && (
                                                <EditOrganizationDialog
                                                    data={selectedOrganizationData}
                                                    onClose={handleCloseEditOrganization}
                                                />
                                            )}
                                            {showDeleteConfirmationDialog && (
                                                <DeleteConfirmationDialog
                                                    onClose={handleClose}
                                                    onYes={handleDeleteOrganization}
                                                    name="organization"
                                                />
                                            )}
                                        </TableBody>
                                    </Table>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </MainCard>
        );
    }
};

export default ManagementOrganizations;
